import axios from 'axios';
import type { Annotation } from '@/types/annotation';

const API_BASE_URL = '/api/project';

class AnnotationService {
  /**
   * Save annotation data for a document
   */
  async saveAnnotation(
    projectId: number,
    documentId: number,
    annotationData: string
  ): Promise<Annotation> {
    const response = await axios.post(
      `${API_BASE_URL}/${projectId}/documents/${documentId}/annotations`,
      { annotationData }
    );
    return response.data;
  }

  /**
   * Get the latest annotation for a document
   */
  async getLatestAnnotation(
    projectId: number,
    documentId: number
  ): Promise<Annotation | null> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/${projectId}/documents/${documentId}/annotations/latest`
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null; // No annotations exist yet
      }
      throw error;
    }
  }

  /**
   * Delete annotations for a document
   */
  async deleteAnnotation(
    projectId: number,
    documentId: number
  ): Promise<void> {
    await axios.delete(
      `${API_BASE_URL}/${projectId}/documents/${documentId}/annotations`
    );
  }
}

export default new AnnotationService();
